import firebase from 'firebase/app'
const db = firebase.firestore()
var moment = require('moment')

const state = {
  isLoggedIn: false,
  user: null,
  users: [],
  loading: false,
  error: null,
  genderOptions: [
    { value: 'male', text: 'Мужской' },
    { value: 'female', text: 'Женский' }
  ],
  statusOptions: [
    { text: 'Active', value: true },
    { text: 'Inactive', value: false }
  ],
  subjectPaymentOptions: [
    { text: 'Free', value: true },
    { text: 'Paid', value: false }
  ],
  publicUser: null,
  userCount: 0
}

const actions = {
  GOOGLE_SIGN_IN ({ commit, dispatch }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    return new Promise((resolve, reject) => {
      firebase.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider())
        .then(res => {
          commit('SET_LOADING', false)
          commit('SET_LOADED_USER', res.user)
          db.collection('users').doc(res.user.uid).get().then(doc => {
            if (!doc.exists) {
              db.collection('users').doc(res.user.uid).set({
                id: res.user.uid,
                email: res.user.email,
                name: res.user.displayName,
                photoUrl: res.user.photoURL,
                createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
                updatedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
                isAdmin: false,
                isActive: true,
                isPaid: false
              })
              dispatch('GET_USER')
              resolve(doc)
            } else {
              db.collection('users').doc(res.user.uid).update({
                lastLogin: moment().format()
              })
              dispatch('GET_USER')
              resolve(doc)
            }
          })
        })
        .catch(err => {
          commit('SET_LOADING', false)
          commit('SET_ERROR', err)
        })
    })
  },
  LOGIN_USER ({ commit }, { email, password }) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    firebase.auth().signInWithEmailAndPassword(email, password).then((userRes) => {
      // var user = firebase.auth().currentUser
      // commit('SET_LOADED_USER', user)

      db.collection('users').doc(userRes.user.uid).get().then((doc) => {
        if (doc.exists) {
          db.collection('users').doc(userRes.user.uid).update({
            lastLogin: moment().format()
          })
          commit('SET_LOADED_USER', doc.data())
          commit('SET_LOADING', false)
        } else {
          commit('SET_LOADING', false)
        }
      })
    }).catch(error => {
      commit('SET_LOADING', false)
      commit('SET_ERROR', error)
    })
  },
  REGISTER ({ commit, dispatch }, form) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    firebase.auth().createUserWithEmailAndPassword(form.email, form.password).then((response) => {
      // create user obj
      let collectionType = 'users'
      let collectionId = response.user.uid
      db.collection(collectionType).doc(collectionId).set({
        id: response.user.uid,
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        lastLogin: moment().format(),
        created: moment().format(),
        onboardingComplete: form.onboardingComplete
      }).then(() => {
        commit('SET_LOADING', false)
        // commit('SET_LOADED_USER', response.user)
        dispatch('GET_USER')
      }).catch(error => {
        commit('SET_LOADING', false)
        commit('SET_ERROR', error)
      })
    }).catch(error => {
      commit('SET_LOADING', false)
      commit('SET_ERROR', error)
    })
  },
  RESET_PASSWORD ({ commit }, { email }) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    firebase.auth().sendPasswordResetEmail(email).then(() => {
      commit('SET_LOADING', false)
    }).catch(error => {
      commit('SET_LOADING', false)
      commit('SET_ERROR', error)
    })
  },
  AUTO_SIGN_IN ({ commit }, payload) {
    db.collection('users').doc(payload.email).get().then((doc) => {
      if (doc.exists) {
        commit('SET_LOADED_USER', doc.data())
      } else {
        db.collection('students').doc(payload.uid).get().then((doc) => {
          if (doc.exists) {
            commit('SET_LOADED_USER', doc.data())
          }
        })
      }
    })
    // commit('SET_LOADED_USER')
    // commit('SET_LOADED_USER', payload)
  },
  GET_USER_COUNT ({ commit }) {
    db.collection('users').get().then((querySnapshot) => {
      commit('SET_USER_COUNT', querySnapshot.size)
    })
  },
  LOGOUT ({ commit }) {
    firebase.auth().signOut()
    window.location.href = window.location.href
    localStorage.removeItem('token')
  },
  SET_LOADING ({ commit }, payload) {
    commit('SET_LOADING', payload)
  },
  SET_ERROR ({ commit }, payload) {
    commit('SET_ERROR')
  },
  CLEAR_ERROR ({ commit }) {
    commit('CLEAR_ERROR')
  },
  GET_USER ({ commit, state }) {
    if (state.user) {
      var id = state.user.id
      if (state.user && state.user.id) {
        id = state.user.id
      } else if (state.user && state.user.uid) {
        id = state.user.uid
      }
      return new Promise((resolve, reject) => {
        db.collection('users').doc(id).get().then((doc) => {
          if (doc.exists) {
            commit('SET_LOADED_USER', doc.data())
            resolve(doc)
          }
        })
      })
    }
  },
  GET_USER_BY_ID ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('users').doc(payload).get().then((doc) => {
        if (doc.exists) {
          commit('SET_LOADED_USER', doc.data())
          resolve(doc)
        }
      })
    })
  },
  UPDATE_PROFILE ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('users').doc(state.user.id).update(payload.form).then(() => {
        resolve(payload)
      })
    })
  },
  GET_PUBLIC_PROFILE ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let collectionType = 'users'
      let collectionId = payload
      db.collection(collectionType).doc(collectionId).get().then((doc) => {
        if (doc) {
          commit('SET_LOADED_PUBLIC_USER', doc.data())
          resolve(doc.data())
        }
      })
    })
  },
  GET_ALL_USERS ({ commit }) {
    return new Promise((resolve, reject) => {
      db.collection('users').limit(50).get().then((snapshot) => {
        let users = []
        snapshot.forEach((doc) => {
          users.push(doc.data())
        })
        commit('SET_LOADED_USERS', users)
        resolve(users)
      })
    })
  }
}

const getters = {
  loadedUser: (state) => (id) => {
    return state.users.find(user => user.id === id)
  },
  getUser (state) {
    return state.user
  },
  isLoading (state) {
    return state.loading
  },
  getError (state) {
    return state.error
  }
}

const mutations = {
  SET_LOADED_USER (state, payload) {
    state.user = payload
  },
  SET_LOADING (state, payload) {
    state.loading = payload
  },
  SET_ERROR (state, payload) {
    state.error = payload
  },
  CLEAR_ERROR (state) {
    state.error = null
  },
  LOGOUT (state) {
    state.user = null
    state.token = null
    state.isLoggedIn = false
  },
  SET_LOADED_PUBLIC_USER (state, payload) {
    state.publicUser = payload
  },
  SET_LOADED_USERS (state, payload) {
    state.users = payload
  },
  SET_USER_COUNT (state, payload) {
    state.userCount = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
